import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BrowserDimensions } from '@panamax/app-state/lib/models/platform.model';
import {
  PaymentRowText,
  PaymentViewModel,
} from '@payments/models/payment-activity-page-view-model';
import { PaymentMethod, Status } from '@usf/payment-types';

@Component({
  template: '',
})
export class PaymentRowBaseComponent {
  @Input() vm: PaymentViewModel;
  @Input() browserDimensions: BrowserDimensions;
  @Input() isTouch: boolean;
  @Input() isMobile: boolean;
  @Input() selectable: boolean;
  @Input() shouldShowButtons = true;
  @Input() canCancelPayment = false;
  @Input() paymentRowText: PaymentRowText;

  @Output() moreOptionsClickEmitter: EventEmitter<{
    event: Event;
    payment: PaymentViewModel;
    canCancel: boolean;
  }> = new EventEmitter();
  @Output()
  referenceNumClickEmitter = new EventEmitter<{ payment: PaymentViewModel }>();

  Status = Status;
  PaymentMethod = PaymentMethod;

  showButtons = true;

  constructor() {}

  onMoreOptionsClick(event: Event) {
    this.moreOptionsClickEmitter.emit({
      event,
      payment: this.vm,
      canCancel: this.canCancelPayment,
    });
  }

  onReferenceNumberClick() {
    this.referenceNumClickEmitter.emit({ payment: this.vm });
  }
}
